module.exports = __webpack_public_path__ + "img/sleep-sidebar.48cd8f19.svg";